import { render, staticRenderFns } from "./CurriculumDetails.vue?vue&type=template&id=1ce1767c&scoped=true"
import script from "./CurriculumDetails.vue?vue&type=script&lang=js"
export * from "./CurriculumDetails.vue?vue&type=script&lang=js"
import style0 from "./CurriculumDetails.vue?vue&type=style&index=0&id=1ce1767c&prod&scoped=true&lang=css"
import style1 from "./CurriculumDetails.vue?vue&type=style&index=1&id=1ce1767c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce1767c",
  null
  
)

export default component.exports